import React from "react";
import { Modal } from "semantic-ui-react";
import "./BasicModal.scss";

export function BasicModal(props) {
  const { show, close, title, size, children, className, scrolling } = props;

  return (
    <Modal closeIcon open={show} onClose={close} size={size} className={`basic-modal ${className}`}>
      {title && <Modal.Header>{title}</Modal.Header>}
      <Modal.Content scrolling={scrolling}>{children}</Modal.Content>
    </Modal>
  );
}

BasicModal.defaultProps = {
  size: "tiny",
  className: "",
  // Default to an internal scroll region (BasicModal.scss bounds
  // `> .scrolling.content` to max-height + overflow-y:auto) so a modal taller
  // than the viewport never gets cut off with its content unreachable.
  //
  // Tradeoff: `.scrolling.content` clips any open dropdown menu that extends
  // past its bounds (overflow:auto on an ancestor always clips absolutely-
  // positioned descendants, regardless of z-index). This is fine for the vast
  // majority of modals. Forms that host their OWN inner bounded scroll region
  // for a long list (RolePermissionForm / AssignTeacherForm /
  // SyllabuSubjectGradeForm) must pass `scrolling={false}` to keep their filter
  // selects unclipped and avoid a double scrollbar.
  scrolling: true,
};
